import { TOKENS_ID } from "application/constants/app-constants";

export default function getTokenId() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return TOKENS_ID[urlParams?.get("country") ?? "gb"] ?? TOKENS_ID["gb"];
}
